export default "__VITE_ASSET__DymUcOgD__"